/* DENMARY product pages (pilot 15.10.2026), behaviour of the dm-pdp landing blocks (snippets/dm-pdp-*).
   - Design yours: every a[href="#ld-designer"] is bound by the LETTERING DESIGNER itself (sections/ld-one), nothing to do here.
   - dates Order today - Posted - With you: same working-day rule as snippets/dmv-pdp-extras (Mon-Fri, England and Wales bank holidays).
   - films: poster first, play muted when half on screen, tap = pause/play, round sound button (how-to film too, no YouTube since 16.10).
   - example cards a.dmp-pick: open the designer with ?design=<preset id>.
   - sticky Design yours: phone/tablet after the first scroll, computer once the main button is off screen. */
(function () {
  // 16.10 fix: the page has TWO .dmp blocks (hero section + body section); search the whole page, not only the first one
  if (!document.querySelector('.dmp')) return;
  var root = document;
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var hol = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function work(d) { var w = d.getDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(d)) < 0; }
  function add(n) { var d = new Date(); d.setHours(12, 0, 0, 0); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (work(d)) k++; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function short(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  var o = $('[data-eta="o"]'), r = $('[data-eta="r"]'), dd = $('[data-eta="d"]');
  if (o) o.textContent = fmt(new Date());
  // 17.10 family pages: working days can come from data-days / data-from / data-to (defaults = the iron-on pages: 2, 3-5)
  function num(e, a, d) { var x = e && parseInt(e.getAttribute(a), 10); return x > 0 ? x : d; }
  if (r) r.textContent = 'by ' + fmt(add(num(r, 'data-days', 2)));
  if (dd) dd.textContent = short(add(num(dd, 'data-from', 3))) + ' - ' + short(add(num(dd, 'data-to', 5)));

  // 29.10.2026 task 05 (A-09): Christmas line under the dates. THE DATES LIVE HERE, change them once a year.
  // Source: Royal Mail last posting dates for inland services, Christmas 2026, https://www.royalmail.com/christmas/last-posting-dates
  // (checked 29.10.2026). Standard post on the page = Royal Mail 2nd Class (Free UK delivery goes Tracked 48: 19 Dec, a Saturday,
  // I post Mon-Fri, so 2nd Class 18 Dec is the earliest date that counts for both).
  // MODELLED, not a Royal Mail promise: order by = last posting date (std) minus the making time of the page in working days
  // (data-days of "Posted", 1-2 days pages use 2), Mon-Fri, bank holidays above. Example: ornaments 3 days -> Tue 15 Dec, transfers -> Wed 16 Dec.
  //  - from 15 Nov (Denis: the peak starts 15.11) to 23 Dec, the posting day is not after the last date: "Order by <date> for Christmas (standard post)."
  //  - the posting day is after the last date (any day of the year up to 24 Dec): "By standard post this may arrive after Christmas. ..."
  //    + the Express hint while the posting day is not after the Special Delivery last date (23 Dec), else the short line.
  var XMAS = { day: '2026-12-25', from: '2026-11-15', std: '2026-12-18', t48: '2026-12-19', t24: '2026-12-21', express: '2026-12-23' };
  (function () {
    if (!r) return;
    var now = new Date(), q = /[?&]dm_today=(\d{4}-\d{2}-\d{2})/.exec(location.search); // dm_today = test a date, e.g. ?dm_today=2026-12-17
    function at(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2], 12, 0, 0, 0); }
    var today = q ? at(q[1]) : new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0);
    var days = num(r, 'data-days', 2), xd = at(XMAS.day), last = at(XMAS.std);
    function addFrom(d0, n) { var d = new Date(d0); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (work(d)) k++; } return d; }
    if (q) r.textContent = 'by ' + fmt(addFrom(today, days));
    if (today >= xd || iso(today).slice(0, 4) !== XMAS.day.slice(0, 4)) return;
    function back(d0, n) { var d = new Date(d0); var k = 0; while (k < n) { d.setDate(d.getDate() - 1); if (work(d)) k++; } return d; }
    var posted = addFrom(today, days), txt = '';
    if (posted > last) txt = posted > at(XMAS.express) ? 'This may arrive after Christmas.' : 'By standard post this may arrive after Christmas. Express at checkout may still get it there in time.';
    else if (today >= at(XMAS.from)) txt = 'Order by ' + fmt(back(last, days)) + ' for Christmas (standard post).';
    if (!txt) return;
    var box = r.closest('.dmp-tlw') || r.parentNode.parentNode, p = document.createElement('p');
    p.className = 'dm5-xmas'; p.setAttribute('data-dm5-xmas', ''); p.textContent = txt;
    var note = box.querySelector('.dmp-tlnote'); if (note) box.insertBefore(p, note.nextSibling); else box.appendChild(p);
  })();

  // films (16.10 fix): one behaviour for every film on the page
  //   poster shown before play · plays muted when half of it is on screen, pauses when it leaves
  //   tap on the picture = play / pause · round sound button bottom right (+ volume slider on a computer)
  //   reduced motion = no autoplay, play button only
  var wide = window.matchMedia && matchMedia('(min-width:768px)').matches;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var IC_OFF = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';
  var IC_ON = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  function film(v, wrap, box, silent) {
    if (!v || !wrap) return;
    box = box || wrap;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true;
    var userPaused = false;
    function sync() { wrap.classList.toggle('dmp-paused', v.paused); }
    v.addEventListener('play', sync); v.addEventListener('pause', sync); v.addEventListener('playing', sync);
    function go() { var p = v.play(); if (p && p.catch) p.catch(function () { sync(); }); }
    function toggle() { if (v.paused) { userPaused = false; go(); } else { userPaused = true; v.pause(); } }
    var pb = box.querySelector('.dmp-play');
    if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); userPaused = false; go(); });
    v.addEventListener('click', toggle);
    if (!silent) {
      var vc = document.createElement('div'); vc.className = 'dmp-vc';
      vc.innerHTML = '<input class="dmp-vol" type="range" min="0" max="1" step="0.05" value="0.8" aria-label="Volume"><button class="dmp-mute" type="button" aria-pressed="false" aria-label="Turn sound on">' + IC_OFF + '</button>';
      box.appendChild(vc);
      var mb = vc.querySelector('.dmp-mute'), vol = vc.querySelector('.dmp-vol');
      v.volume = 0.8;
      function paint() { var on = !v.muted && v.volume > 0; mb.innerHTML = on ? IC_ON : IC_OFF; mb.setAttribute('aria-pressed', on ? 'true' : 'false'); mb.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); vol.value = v.muted ? 0 : v.volume; }
      mb.addEventListener('click', function (e) { e.stopPropagation(); if (v.muted || v.volume === 0) { v.muted = false; if (v.volume === 0) v.volume = 0.8; userPaused = false; if (v.paused) go(); } else v.muted = true; paint(); });
      vol.addEventListener('input', function () { var x = parseFloat(vol.value); v.volume = x; v.muted = x === 0; if (!v.muted && v.paused) { userPaused = false; go(); } paint(); });
      vc.addEventListener('click', function (e) { e.stopPropagation(); });
      v.addEventListener('volumechange', paint);
    }
    sync();
    if ('IntersectionObserver' in window && !still) {
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!userPaused) go(); }
        else if (!v.paused) { v.pause(); }
      }); }, { threshold: [0, 0.5] }).observe(v);
    }
  }
  // sport: workshop film (wide / portrait) + peel film (no sound track)
  var mk = document.getElementById('dmp-mkVid'), mw = document.getElementById('dmp-mk');
  if (mk && mw) {
    if (wide && mk.getAttribute('data-pw')) mk.poster = mk.getAttribute('data-pw');
    mk.src = wide ? mk.getAttribute('data-w') : mk.getAttribute('data-p');
    film(mk, mw, mw.querySelector('.dmp-mbox'), false);
  }
  var pv = document.getElementById('dmp-peelVid'); if (pv) film(pv, document.getElementById('dmp-peel'), null, true);
  // designs / lettering workshop film: 4:5 on a phone, 16:9 from 768 px
  var fw = document.getElementById('dmp-film'), fv = document.getElementById('dmp-filmVid');
  if (fw && fv) { var fp = fw.getAttribute(wide ? 'data-p169' : 'data-p45'); if (fp) fv.poster = fp; fv.src = fw.getAttribute(wide ? 'data-v169' : 'data-v45'); film(fv, fw, null, false); }
  // designer film in See how it works: 4:5 under 600 px, 16:9 from 600 px (snippets/dm-pdp-designer-video)
  var dw = document.getElementById('dmp-dvid'), dv = dw && dw.querySelector('video');
  if (dw && dv) {
    var dwide = window.matchMedia && matchMedia('(min-width:600px)').matches;
    var dp = dw.getAttribute(dwide ? 'data-p169' : 'data-p45'); if (dp) dv.poster = dp;
    dv.src = dw.getAttribute(dwide ? 'data-v169' : 'data-v45');
    film(dv, dw, null, false);
  }

  // how-to film "On in 2 minutes" (16.10 Denis: own film on the page, no YouTube): 4:5 on a phone, 16:9 from 768 px, same player as the other films
  var hw = document.getElementById('dmp-how'), hv = hw && hw.querySelector('video');
  if (hw && hv) { var hp = hw.getAttribute(wide ? 'data-p169' : 'data-p45'); if (hp) hv.poster = hp; hv.src = hw.getAttribute(wide ? 'data-v169' : 'data-v45'); film(hv, hw, null, false); }

  // 17.10 family pages: any other film box marked data-dmp-film (How I make it): 4:5 under data-bp px (default 768), 16:9 from it
  $$('[data-dmp-film]').forEach(function (w) {
    var v = w.querySelector('video'); if (!v || v.getAttribute('src')) return;
    var bp = parseInt(w.getAttribute('data-bp') || '768', 10);
    var wd = window.matchMedia && matchMedia('(min-width:' + bp + 'px)').matches;
    var p = w.getAttribute(wd ? 'data-p169' : 'data-p45'); if (p) v.poster = p;
    var src = w.getAttribute(wd ? 'data-v169' : 'data-v45'); if (!src) return;
    v.src = src; film(v, w, null, false);
  });

  // example cards (16.10 Denis): a tap opens the LETTERING DESIGNER with that design. The designer (ld-one.js, not changed here) reads
  // ?design=<preset id> once, when it first loads. Not loaded yet: put the id in the address and open it here, no reload.
  // Already loaded on this page: go to the address, the page opens again with the designer and that design. No id (style cards): just open.
  $$('a.dmp-pick').forEach(function (a) { a.addEventListener('click', function (e) {
    var id = a.getAttribute('data-design') || '', opener = document.querySelector('a[href="#ld-designer"]');
    var loaded = !!document.querySelector('script[src*="ld-one.js"]');
    if (!opener) return;                                          // no designer on the page: the link reloads with ?design=
    e.preventDefault();
    if (!id) { opener.click(); return; }
    var u = new URL(location.href); u.searchParams.set('design', id); u.hash = 'ld-designer';
    if (loaded) { location.assign(u.toString()); return; }
    try { history.replaceState(history.state, '', u.toString()); } catch (x) { location.assign(u.toString()); return; }
    opener.click();
  }); });

  // gallery thumbnails (tablet and computer)
  var hero = $('#dmp-heroImg');
  $$('[data-th]').forEach(function (b) { b.addEventListener('click', function () { $$('[data-th]').forEach(function (c) { c.removeAttribute('aria-current'); }); b.setAttribute('aria-current', 'true'); var f = b.getAttribute('data-full') || (b.querySelector('img') || {}).src; if (hero && f) { hero.removeAttribute('srcset'); hero.src = f; } }); });

  // ready designs: occasion chips are plain links to collections (16.10), nothing to do here

  // 17.10 family buy form (snippets/dm-pdp-hero-family): options as buttons -> variant id, price, photo; Add to basket the theme's way
  //   a value is greyed out when no variant in stock has it together with the values picked in the options before it
  //   personalisation fields (snippets/dm-personalise) check themselves on the button click before the form is sent
  var fb = document.getElementById('dmp-buy'), fvs = document.getElementById('dmp-fvariants');
  if (fb && fvs) (function () {
    var form = fb.querySelector('form'), idIn = form && form.querySelector('[name="id"]'), btn = document.getElementById('dmp-buyMain');
    if (!form || !idIn || !btn) return;
    var V = []; try { V = JSON.parse(fvs.textContent || '[]'); } catch (x) { V = []; }
    var groups = Array.prototype.slice.call(fb.querySelectorAll('.dmp-opt'));
    var sel = groups.map(function (g) { var on = g.querySelector('.dmp-ochip.is-on'); return on ? on.getAttribute('data-v') : null; });
    var priceEl = document.getElementById('dmp-priceVal'), stPrice = document.getElementById('dmp-stPrice');
    var label = btn.getAttribute('data-original-text') || 'Add to basket', txt = btn.querySelector('[data-button-text]');
    function prior(v, i) { for (var k = 0; k < i; k++) if (v.o[k] !== sel[k]) return false; return true; }
    function can(i, val) { return V.some(function (v) { return v.a && v.o[i] === val && prior(v, i); }); }
    function find() { for (var j = 0; j < V.length; j++) { var ok = true; for (var k = 0; k < sel.length; k++) if (V[j].o[k] !== sel[k]) { ok = false; break; } if (ok) return V[j]; } return null; }
    function paint(user) {
      groups.forEach(function (g, i) {
        g.querySelectorAll('.dmp-ochip').forEach(function (c) {
          var val = c.getAttribute('data-v'), on = val === sel[i];
          c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
          var off = !can(i, val); c.classList.toggle('is-off', off); c.disabled = off && !on;
        });
        var sp = g.querySelector('[data-sel]'); if (sp) sp.textContent = sel[i] || '';
      });
      var v = groups.length ? find() : (V[0] || null);
      if (v) { idIn.value = v.id; idIn.setAttribute('value', v.id); }
      var ok = !!(v && v.a);
      btn.disabled = !ok; btn.setAttribute('data-original-text', ok ? label : (v ? 'Sold out' : 'Not available'));
      if (txt) txt.textContent = btn.getAttribute('data-original-text');
      if (user && v) {
        if (priceEl) priceEl.textContent = v.p;
        if (stPrice) stPrice.textContent = v.p;
        var hi = document.getElementById('dmp-heroImg'); if (hi && v.m) { hi.removeAttribute('srcset'); hi.src = v.m; }
      }
    }
    groups.forEach(function (g, i) {
      g.addEventListener('click', function (e) {
        var c = e.target.closest && e.target.closest('.dmp-ochip'); if (!c || c.disabled) return;
        sel[i] = c.getAttribute('data-v');
        // later options: keep the pick if it is still in stock with the new value, else take the first one in stock
        for (var j = i + 1; j < groups.length; j++) {
          if (can(j, sel[j])) continue;
          var first = Array.prototype.slice.call(groups[j].querySelectorAll('.dmp-ochip')).map(function (x) { return x.getAttribute('data-v'); }).filter(function (val) { return can(j, val); })[0];
          if (first != null) sel[j] = first;
        }
        paint(true);
      });
    });
    paint(false);
    // Add to basket: Booster's own add (mini basket / message as set in the theme); AJAX cart off or no Booster = normal form post
    form.addEventListener('submit', function (e) {
      if (fb.getAttribute('data-ajax') === 'disabled') return;
      if (typeof BoosterTheme === 'undefined' || !BoosterTheme.cart || typeof BoosterTheme.cart.addToCart !== 'function') return;
      e.preventDefault();
      BoosterTheme.cart.addToCart({ currentTarget: btn, preventDefault: function () {}, stopImmediatePropagation: function () {} }, form);
    });
  })();
  // 17.10 canon E14: "You typed: ..." above Add to basket = the personalisation texts exactly as typed (not the optional note);
  // while it shows, the same spelling line inside the fields box is hidden (one fact once on the page)
  var echo = document.getElementById('dmp-echo'), echoTxt = document.getElementById('dmp-echoTxt');
  if (echo && echoTxt) {
    var echoT = null;
    var echoUp = function () {
      var box = document.getElementById('dm-personalise'); if (!box) return;
      var ins = Array.prototype.slice.call(box.querySelectorAll('input.dmpz__i, textarea.dmpz__i')).filter(function (i) { var w = i.closest('.dmpz__f'); return !i.closest('.dmpz__more') && !(w && w.hidden); });
      echo.hidden = !ins.length; box.classList.toggle('dmp-echo-on', !!ins.length);
      var vals = ins.filter(function (i) { return i.value !== ''; });
      echoTxt.textContent = '';
      vals.forEach(function (i, k) { if (k) echoTxt.appendChild(document.createTextNode('  ·  ')); echoTxt.appendChild(document.createTextNode('\u201C' + i.value + '\u201D')); });
      echoTxt.parentNode.hidden = !vals.length;
    };
    var echoLater = function () { clearTimeout(echoT); echoT = setTimeout(echoUp, 80); };
    document.addEventListener('input', echoLater, true); document.addEventListener('change', echoLater, true); document.addEventListener('click', echoLater, true);
    var echoN = 0, echoWait = setInterval(function () { if (document.getElementById('dm-personalise') || ++echoN > 40) { clearInterval(echoWait); echoUp(); } }, 150);
  }

  // sticky button of the family page scrolls to the buy form (the form has scroll-margin for the theme header)
  $$('a[href="#dmp-buy"]').forEach(function (a) { a.addEventListener('click', function (e) {
    var t = document.getElementById('dmp-buy'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  }); });

  // sticky Design yours
  var st = $('.dmp-sticky'), cta = $('#dmp-buyMain');
  if (st && cta && !st.hasAttribute('data-dm5')) { // 29.10 task 05: pages with snippets/dm-pdp5-ui run their own bar rule (A-06)
    document.body.classList.add('dmp-has-sticky');
    var chk = function () { var on = innerWidth < 1024 ? window.scrollY > 40 : cta.getBoundingClientRect().bottom < 0; st.classList.toggle('dmp-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    window.addEventListener('scroll', chk, { passive: true }); chk();
  }
})();
